import Modal from 'react-bootstrap/Modal'
import { useIntl } from 'react-intl'

import ChooseCinemaContent from 'components/Header/components/HeaderContent/components/ChooseCinemaContent/ChooseCinemaContent'
import { normalizeCinemaId } from 'global/helpers/cinemaList'
import { getCinemaSlug } from 'pages/Hall/helpers'
import hocCinemaSelectWindow from './hocCinemaSelectWindow'
import './CinemaSelectWindow.scss'

export function CinemaSelectWindow({ isOpen, confirmCinemaSelect }) {
    const intl = useIntl()
    if (!isOpen) return null

    const handleConfirm = (cinema) => {
        const cinemaid = normalizeCinemaId(cinema?.id)
        if (!cinemaid) return

        localStorage.setItem('cinemaid', cinemaid)
        localStorage.setItem('site', getCinemaSlug(cinemaid))
        confirmCinemaSelect(cinemaid)
    }

    return (
        <Modal
            show
            centered
            scrollable
            size="xl"
            animation={false}
            backdrop="static"
            keyboard={false}
            className="cinema-select-window"
            backdropClassName="cinema-select-backdrop"
            aria-label={intl.formatMessage({ id: 'modals.modalCinemaSelect.title' })}
        >
            <Modal.Body>
                <ChooseCinemaContent onConfirm={handleConfirm} titleId="modals.modalCinemaSelect.title" />
            </Modal.Body>
        </Modal>
    )
}

export default hocCinemaSelectWindow(CinemaSelectWindow)
